var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabletFinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "269px",
    height: "166px",
    viewBox: "0 0 269 166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "taikasormi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tasks-Copy-2",
    transform: "translate(-413.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taikasormi",
    transform: "translate(413.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#292B2C",
    x: 0,
    y: 0,
    width: 269,
    height: 166,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#FFFFFF",
    x: 28,
    y: 11,
    width: 227,
    height: 145
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#289A62",
    strokeWidth: 6,
    strokeLinecap: "round",
    points: "110 83 137 118 190 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.555973,84.070681 C247.370708,85.4673709 247.021536,87.2132333 245.857628,88.1443599 L231.774338,99.5506607 C229.446521,101.412914 226.187578,101.412914 223.743371,99.6670516 C216.410749,94.080292 207.215874,92.1016479 207.215874,92.1016479 C204.888057,91.6360846 202.793022,90.9377397 200.697987,89.4246589 C199.301298,88.3771415 197.206263,87.3296241 195.809573,86.3984975 C192.201457,83.9542902 188.244169,81.8592553 183.937709,80.4625654 C182.075455,79.8806113 181.609892,78.716703 182.308237,76.8544498 C182.65741,75.9233232 183.704927,74.759415 184.636054,74.2938517 C186.731088,73.2463342 188.942514,73.3627251 190.921158,73.7118975 C192.201457,73.8282884 197.788217,76.5052773 200.232424,77.5527948 C202.44385,78.3675305 202.793022,76.3888865 202.560241,74.06107 C202.44385,72.8971618 202.094677,71.8496443 201.512723,70.8021269 C196.624309,61.7236425 191.503112,52.8779398 186.498307,43.9158463 C185.334399,41.9372022 185.799962,39.8421674 187.545824,38.6782591 C189.291687,37.5143509 191.619503,37.8635233 193.016193,39.6093857 C194.994837,42.0535931 196.85709,44.4978004 198.719343,46.9420077 C200.465206,49.1534334 202.211068,51.4812499 204.073321,53.8090664 L206.284747,56.4860554 C206.284747,56.4860554 219.204129,51.4812499 233.985764,54.9729747 C234.800499,55.2057563 235.498844,55.6713196 235.848017,56.4860554 C237.477488,59.5122168 241.783949,67.8923563 242.831466,75.9233232 C243.41342,78.0183581 244.228156,79.7642204 244.693719,80.9281287 L246.555973,84.070681 Z",
    id: "Path",
    fill: "#292B2C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#FFFFFF",
    cx: 13.5,
    cy: 85.5,
    r: 6.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletFinger);
export default __webpack_public_path__ + "static/media/tablet_finger.ec61ec981a3cabf4d59363475c653511.svg";
export { ForwardRef as ReactComponent };